<template>
  <svg
    viewBox="0 0 477 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M156.788 90.219L166.103 105.573L156.788 120H336.35L328.345 105.573L336.35 90.219H156.788Z"
      fill="#4F2B1B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.1556 18.3942L27.1183 43.5492L20.714 18.3942H0V29.1171H3.67306V68.1968H0V78.8321H17.7527V68.1968H14.6922V30.7115L23.6969 66.6011L28.7693 66.6268L38.8276 30.8017L37.9532 68.1968H34.9817V78.8321H54.3066V68.1968H50.6335V29.1171H54.3066V18.3942H34.1556Z"
      fill="#4F2B1B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M58.6862 78.8321V68.198H62.4556V29.1171H58.6862V18.3942H80.584V29.1171H76.8146V68.198H80.584V78.8321H58.6862Z"
      fill="#4F2B1B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M84.0876 78.8321V68.198L86.6448 68.1993L98.4581 49.5005L86.5577 29.1171H84.3516V18.3942H103.657V29.1171H100.395L105.627 38.1207L111.307 29.1055L107.976 29.1171V18.3942H125.256V29.1171H123.403L111.679 47.7271L123.201 68.198H125.256V78.8321H106.037V68.198H109.122L104.363 59.1596L98.7464 68.2148L101.453 68.198V78.8321H84.0876Z"
      fill="#4F2B1B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M127.883 78.8321V68.198H131.653V29.1171H127.883V18.3942H149.781V29.1171H146.012V68.198H149.781V78.8321H127.883Z"
      fill="#4F2B1B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M163.23 78.8321V68.198H166.893V28.3199H162.27V37.6249H154.161V18.3942H193.577V37.6249H185.467V28.3199H180.845V68.198H184.421V78.8321H163.23Z"
      fill="#4F2B1B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M185.309 104.772H186.324C187.111 104.772 187.643 104.649 187.92 104.403C188.197 104.156 188.334 103.672 188.334 102.946V101.717C188.334 101.101 188.185 100.682 187.889 100.455C187.592 100.23 187.056 100.117 186.283 100.117H185.309V104.772ZM181.703 112.386V110.565H182.864V100.117H181.703V98.2954H186.675C188.058 98.2954 189.071 98.5616 189.713 99.0938C190.356 99.6235 190.675 100.49 190.675 101.69V103.138C190.675 104.323 190.404 105.195 189.858 105.756C189.312 106.314 188.459 106.592 187.298 106.592H185.309V110.565H186.49V112.386H181.703Z"
      fill="#FEFEFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M195.402 104.131H196.791C197.399 104.131 197.844 104.017 198.128 103.791C198.411 103.566 198.552 103.198 198.552 102.689V101.475C198.552 100.94 198.408 100.581 198.117 100.395C197.828 100.211 197.33 100.117 196.625 100.117H195.402V104.131ZM193.723 93.9507H194.947L196.5 95.6894L198.055 93.9507H199.278L197.516 96.8485H195.484L193.723 93.9507ZM191.797 112.386V110.565H192.957V100.117H191.797V98.2956H196.791C198.283 98.2956 199.339 98.5271 199.962 98.989C200.584 99.4522 200.894 100.275 200.894 101.462V102.394C200.894 103.261 200.721 103.893 200.376 104.286C200.03 104.679 199.409 104.938 198.511 105.062C199.394 105.172 200.015 105.385 200.366 105.703C200.718 106.021 200.894 106.545 200.894 107.276V110.565H202.055V112.386H198.552V107.379C198.552 106.8 198.418 106.407 198.149 106.2C197.88 105.993 197.378 105.89 196.647 105.89H195.402V110.565H196.5V112.386H191.797Z"
      fill="#FEFEFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M202.676 112.386V110.565H203.838V100.118H202.676V98.2957H211.693V102.27H209.702V100.118H206.283V103.924H209.185V105.952H206.283V110.565H209.702V108.062H211.754V112.386H202.676Z"
      fill="#FEFEFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M216.647 100.118V110.565H217.102C218.098 110.565 218.811 110.308 219.247 109.793C219.683 109.277 219.9 108.429 219.9 107.247V103.044C219.9 101.958 219.711 101.2 219.331 100.766C218.95 100.333 218.257 100.118 217.248 100.118H216.647ZM213.04 98.2958H216.894C218.885 98.2958 220.291 98.6579 221.112 99.3833C221.935 100.106 222.345 101.359 222.345 103.137V106.862C222.345 108.806 221.959 110.214 221.185 111.082C220.412 111.952 219.133 112.386 217.352 112.386H213.04V110.565H214.201V100.118H213.04V98.2958Z"
      fill="#FEFEFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M227.134 104.772H228.149C228.936 104.772 229.468 104.649 229.745 104.403C230.021 104.156 230.159 103.672 230.159 102.946V101.717C230.159 101.101 230.01 100.682 229.714 100.455C229.416 100.23 228.881 100.117 228.108 100.117H227.134V104.772ZM223.527 112.386V110.565H224.689V100.117H223.527V98.2954H228.5C229.883 98.2954 230.895 98.5616 231.538 99.0938C232.181 99.6235 232.5 100.49 232.5 101.69V103.138C232.5 104.323 232.228 105.195 231.682 105.756C231.136 106.314 230.284 106.592 229.123 106.592H227.134V110.565H228.314V112.386H223.527Z"
      fill="#FEFEFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M233.62 112.386V110.565H234.781V100.118H233.62V98.2957H238.407V100.118H237.226V110.565H240.605V107.98H242.636V112.386H233.62Z"
      fill="#FEFEFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M247.604 106.632L250.237 106.635L248.953 100.911L247.604 106.632ZM243.651 112.386V110.565H244.542L247.319 100.117H246.096V98.2956H252.024V100.117H250.801L253.538 110.565H254.366V112.386H249.911V110.565L251.158 110.563L250.585 108.209L247.228 108.205L246.644 110.561L247.857 110.565V112.386H243.651Z"
      fill="#FEFEFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M255.817 112.386V110.565H257.206V100.055H255.611V102.414H253.93V98.2957H262.947V102.414H261.247V100.055H259.652V110.565H261.061V112.386H255.817Z"
      fill="#FEFEFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M263.982 112.386V110.565H265.143V100.118H263.982V98.2957H268.769V100.118H267.589V110.565H268.769V112.386H263.982Z"
      fill="#FEFEFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M271.692 112.386V110.565H273.081V100.055H271.486V102.414H269.806V98.2957H278.822V102.414H277.122V100.055H275.527V110.565H276.937V112.386H271.692Z"
      fill="#FEFEFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M279.859 112.386V110.565H281.019V100.118H279.859V98.2957H288.872V102.27H286.883V100.118H283.464V103.924H286.366V105.952H283.464V110.565H286.883V108.062H288.935V112.386H279.859Z"
      fill="#FEFEFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M290.221 112.386V110.565H291.381V100.118H290.221V98.2957H295.008V100.118H293.826V110.565H297.206V107.98H299.236V112.386H290.221Z"
      fill="#FEFEFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M305.495 94.5728C305.259 94.5728 305.06 94.6547 304.894 94.8198C304.728 94.9848 304.646 95.1857 304.646 95.4198C304.646 95.6552 304.728 95.8548 304.894 96.0199C305.06 96.1862 305.259 96.2681 305.495 96.2681C305.73 96.2681 305.931 96.1862 306.096 96.0199C306.262 95.8548 306.345 95.6552 306.345 95.4198C306.345 95.1857 306.262 94.9848 306.096 94.8198C305.931 94.6547 305.73 94.5728 305.495 94.5728ZM305.495 93.6401C305.993 93.6401 306.414 93.8129 306.759 94.1583C307.105 94.5025 307.278 94.9298 307.278 95.4416C307.278 95.9252 307.105 96.3372 306.759 96.6813C306.414 97.0268 305.985 97.1995 305.474 97.1995C304.99 97.1995 304.575 97.0268 304.232 96.6813C303.886 96.3372 303.713 95.9252 303.713 95.4416C303.713 94.9298 303.886 94.5025 304.232 94.1583C304.575 93.8129 304.997 93.6401 305.495 93.6401ZM301.329 108.814V100.118H300.169V98.296H304.874V100.118H303.774V108.686C303.774 109.362 303.9 109.856 304.147 110.173C304.397 110.49 304.805 110.648 305.37 110.648C305.923 110.648 306.323 110.49 306.573 110.173C306.822 109.856 306.946 109.362 306.946 108.686V100.118H305.846V98.296H310.551V100.118H309.391V108.814C309.391 111.375 308.051 112.655 305.37 112.655C304.057 112.655 303.056 112.332 302.366 111.685C301.675 111.038 301.329 110.081 301.329 108.814Z"
      fill="#FEFEFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M298.898 78.6337V68.0695H302.603V29.0701H298.898V18.4177H319.799V29.0701H316.712V46.8528L328.353 29.0701H324.296V18.4177H343.786V29.0701L340.485 29.0445L328.858 46.8093L340.782 68.0695H343.875V78.6337H324.032V68.0695H327.384L316.712 47.206V68.0695H319.799V78.6337H298.898Z"
      fill="#4F2B1B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M346.077 78.4575V67.8933H349.782V29.0692H346.077V18.4167H367.596V29.0692H363.891V68.2451H373.857V57.8562H384.88V78.4575H346.077Z"
      fill="#4F2B1B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M390.789 63.2869V29.07H387.084V18.4175H407.985V29.07H404.899V62.5116C404.899 66.2168 406.516 68.0694 409.75 68.0694C413.041 68.0694 414.687 66.2168 414.687 62.5116V29.07H411.601V18.4175H432.414V29.07H428.798V63.2869C428.798 74.2221 422.448 79.6891 409.75 79.6891C403.517 79.6891 398.8 78.2932 395.595 75.5015C392.39 72.7086 390.789 68.6374 390.789 63.2869Z"
      fill="#4F2B1B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M453.93 68.6858H456.575C458.81 68.6858 460.382 68.1727 461.294 67.1454C462.204 66.118 462.66 64.401 462.66 61.9957V57.3296C462.66 55.335 462.161 53.8662 461.162 52.9271C460.161 51.9893 458.516 51.5198 456.223 51.5198H453.93V68.6858ZM453.93 42.0111H456.311C458.545 42.0111 460.102 41.6733 460.985 40.9927C461.867 40.3133 462.308 38.9405 462.308 36.8717V33.5938C462.308 31.7041 461.867 30.3466 460.985 29.5188C460.102 28.6923 458.604 28.2778 456.488 28.2778H453.93V42.0111ZM436.91 78.458V67.8938H440.614V29.0697H436.91V18.4173H458.163C463.924 18.4173 468.157 19.5214 470.863 21.731C473.566 23.9367 474.919 27.4257 474.919 32.1941V33.7844C474.919 37.7864 474.036 40.8187 472.274 42.8785C470.511 44.9397 467.687 46.2345 463.808 46.7642C468.041 47.2926 471.127 48.5848 473.067 50.6382C475.007 52.6943 475.977 55.7457 475.977 59.7938V62.5241C475.977 68.2175 474.713 72.295 472.184 74.7592C469.657 77.2259 465.452 78.458 459.574 78.458H436.91Z"
      fill="#4F2B1B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M268.415 0.0716248C257.616 0.0716248 248.553 7.47052 246.024 17.4667C243.499 7.47052 234.433 0.0716248 223.637 0.0716248C210.883 0.0716248 200.545 10.3927 200.545 23.1243C200.545 29.0595 203.256 34.7913 206.484 39.2501C217.234 54.1093 246.024 87.6097 246.024 87.6097C246.024 87.6097 276.488 52.8683 285.566 39.2501C287.953 35.6741 291.508 29.0595 291.508 23.1243C291.508 10.3927 281.169 0.0716248 268.415 0.0716248Z"
      fill="#4F2B1B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M278.23 27.6018L273.828 24.0846C273.828 24.0846 275.344 13.3835 266.252 12.1937C253.664 10.5522 257.361 28.5856 253.85 31.3044C246.565 23.8799 233.162 18.1084 233.162 18.1084C233.162 18.1084 235.957 37.2652 241.388 44.1498C241.806 44.6872 242.263 45.1465 242.717 45.5405C241.358 44.9917 240.052 44.0807 238.901 42.6183C237.155 40.4177 235.69 36.9556 234.501 33.2709C225.488 31.4464 219.743 27.7092 219.743 27.7092C219.743 27.7092 219.811 27.841 219.903 28.0393L219.626 27.7924C219.757 43.6457 229.605 56.9274 243.128 58.4294C257.929 60.0735 271.549 47.0068 273.597 29.2266L278.23 27.6018Z"
      fill="#F9A52D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M269.106 22.7077C268.721 24.0268 267.354 24.7816 266.03 24.4004C264.718 24.0268 263.959 22.6552 264.34 21.3425C264.713 20.026 266.094 19.2737 267.397 19.6486C268.721 20.026 269.479 21.4014 269.106 22.7077Z"
      fill="#FEFEFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M268.015 22.4017C267.81 23.1143 267.069 23.5352 266.35 23.3241C265.625 23.122 265.213 22.3684 265.417 21.6506C265.625 20.9406 266.379 20.5222 267.088 20.732C267.81 20.938 268.228 21.6801 268.015 22.4017Z"
      fill="#73331C"
    />
  </svg>
</template>
